import { Routes } from '@angular/router';
import {UploadComponent} from './upload/upload.component';
import {ChangePaymentComponent} from '../order-assistant/change-payment/change-payment.component';


export const UploadDocsRoutes: Routes = [
    { path: 'upload-docs/:token', component: UploadComponent },

];
